import { MenuItem } from '@/types';

/**
 * Root / top level side navigation menu
 */
export const rootSideMenu: MenuItem[] = [
  { label: 'Home', path: '/' },
  { label: 'Quick Start', path: '/getting-started' },
  { label: 'Integration Guides', path: '/integration-guides' },
  { label: 'SDK Reference', path: '/sdk_ref' },
  { label: 'Portal', path: '/portal' },
  { label: 'How-To', path: '/knowledge-base/how-to' },
  { label: 'Troubleshooting', path: '/knowledge-base/troubleshooting' },
  { label: 'FAQs', path: '/knowledge-base/faqs' },
  { label: 'Reference', path: '/knowledge-base/reference' },
  { label: 'Glossary', path: '/glossary/phenix-glossary-of-terms' },
];
